export default function ObjectivesSection() {
  const objectives = [
    {
      icon: 'ri-hand-heart-line',
      title: 'Recuperación Ética',
      description: 'Gestionar la recuperación de cartera con respeto y profesionalismo, manteniendo siempre la dignidad del deudor.'
    },
    {
      icon: 'ri-team-line',
      title: 'Relaciones Duraderas',
      description: 'Construir vínculos de confianza con nuestros clientes basados en transparencia, honestidad y resultados comprobables.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovación Continua',
      description: 'Implementar tecnologías y metodologías actualizadas para optimizar procesos y mejorar la experiencia del cliente.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Crecimiento Sostenible',
      description: 'Expandir nuestros servicios manteniendo los más altos estándares de calidad y compromiso con la excelencia.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full mb-6">
            <i className="ri-flag-line text-3xl text-amber-600"></i>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Nuestros Objetivos</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Comprometidos con la excelencia en cada aspecto de nuestro servicio
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {objectives.map((objective, index) => (
            <div 
              key={index}
              className="bg-gray-50 p-8 hover:shadow-xl transition-all duration-300 group border border-gray-100 hover:border-amber-200"
            >
              <div className="w-16 h-16 bg-amber-50 rounded-full flex items-center justify-center mb-6 group-hover:bg-amber-100 transition-colors">
                <i className={`${objective.icon} text-3xl text-amber-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{objective.title}</h3>
              <p className="text-gray-600 leading-relaxed">{objective.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
